export default function isNull(value) {
  return value === null;
}
